
const countryToCode = {
    "bahrain": "BH",
    "canada": "CA",
    "china": "CN",
    "hong kong": "HK",
    "japan": "JP",
    "kuwait": "KW",
    "oman": "OM",
    "qatar": "QA",
    "saudi arabia": "SA",
    "singapore": "SG",
    "south korea": "KR",
    "taiwan": "TW",
    "united arab emirates (uae)": "AE",
    "united states of america": "US"
};

const autocompleteInstances = new Map();

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".address-block").forEach(block => {
        const countrySelect = block.querySelector(".country");
        countrySelect.addEventListener("change", () => {
            setCountry(block, countrySelect.value);
        });
        setCountry(block, countrySelect.value);
    });
});

function setCountry(block, countryName) {
    const address1Field = block.querySelector(".address_1");
    const countryCode = countryToCode[countryName.toLowerCase()] || "US";

    // Détruire autocomplete précédent s’il existe
    if (autocompleteInstances.has(address1Field)) {
        const instance = autocompleteInstances.get(address1Field);
        instance.unbindAll();
    }

    const autocomplete = new google.maps.places.Autocomplete(address1Field, {
        componentRestrictions: { country: [countryCode] },
        fields: ["address_components", "geometry"],
        types: ["address"],
    });

    autocomplete.addListener("place_changed", () => {
        fillInAddress(block, autocomplete);
    });

    autocompleteInstances.set(address1Field, autocomplete);
}

function fillInAddress(block, autocomplete) {
    const place = autocomplete.getPlace();
    const address1Field = block.querySelector(".address_1");
    const address2Field = block.querySelector(".address_2");
    const postalField = block.querySelector(".zipcode");
    const cityField = block.querySelector(".city");
    const stateField = block.querySelector(".state");

    let street_number = "", route = "", postcode = "", city = "", premise = "", state = "", administrative_area = "";
    let sublocality = "", sublocality_lv2 = "", sublocality_lv3 = "", sublocality_lv4 = "";

    for (const component of place.address_components) {
        const type = component.types[0];
        switch (type) {
            case "street_number":
                street_number = component.long_name;
                break;
            case "premise":
                premise = component.long_name;
                break;
            case "route":
                route = component.long_name;
                break;
            case "postal_code":
                postcode = component.long_name;
                break;
            case "postal_code_suffix":
                postcode += `-${component.long_name}`;
                break;
            case "locality":
                city = component.long_name;
                break;
            case "administrative_area_level_1":
                administrative_area = component.long_name;
                state = component.short_name;
                break;
            case "sublocality_level_1":
                sublocality = component.long_name;
                break;
            case "sublocality_level_2":
                sublocality_lv2 = component.long_name;
                break;
            case "sublocality_level_3":
                sublocality_lv3 = component.long_name;
                break;
            case "sublocality_level_4":
                sublocality_lv4 = component.long_name;
                break;
        }
    }

    if (!street_number) street_number = premise;

    if (!route) {
        [sublocality_lv4, sublocality_lv3, sublocality_lv2, sublocality]
            .filter(Boolean)
            .forEach(part => {
                if (route) route += ", ";
                route += part;
            });
    }

    if (!city) city = administrative_area;

    const address1 = `${street_number} ${route}`.trim();
    address1Field.value = address1;
    postalField.value = postcode;
    cityField.value = city;
    stateField.value = state;
    address2Field.focus();
}